var _rect, _rect2, _rect3, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    width: 5,
    height: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 5,
    height: 15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 4,
    height: 9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.5,
    y1: 13,
    x2: 5.5,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 9,
    x2: 12.5,
    y2: 11
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 13,
    x2: 12.5,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCities);
export default __webpack_public_path__ + "static/media/cities.947b84dea6199b78d794eaf57a6a4c68.svg";
export { ForwardRef as ReactComponent };